import React, {useContext} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import CreateProduct from './pages/CreateProduct';
import { AuthProvider } from './context/AuthContext';
import AuthContext from './context/AuthContext';
import Login from './pages/Login';
import ProtectedRoute from './ProtectedRoute';
import OrderDetails from './pages/OrderDetails';
import Orders from './pages/Orders';

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;


const AppContent = () => {
  const { auth } = useContext(AuthContext);

  return (
    <Router>
      <div className={`flex min-h-screen bg-gray-100 ${auth ? '' : 'justify-center items-center'}`}>
        {auth && <Sidebar />}
        <div className={`flex-1 flex flex-col ${auth ? 'overflow-hidden' : 'justify-center'}`}>
          {auth && <Navbar />}
          <main className={` ${auth ? '' : 'flex justify-center'}`}>
            <Routes>
              <Route path='/login' element={<Login />} />
              <Route path='/' element={<ProtectedRoute> <Dashboard /></ProtectedRoute>} />
              <Route path='/products' element={<ProtectedRoute><Products /></ProtectedRoute>} />
              <Route path='/create-product' element={<ProtectedRoute><CreateProduct /></ProtectedRoute>} />
              <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
              <Route path="/orders/:id" element={<ProtectedRoute><OrderDetails /></ProtectedRoute>} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}